import React from 'react';
import queryString from "query-string";
import {useHistory} from 'react-router-dom';
import {RadioButton} from '../../../../../components/radioButton';
import {Filters, Header, Row} from './style';



export const FilterComponent = (props) => {
	const history = useHistory();
	const params = queryString.parse(history.location.search);
	
	const changeLevel = (level) => {		
		history.push('/construction-phase?'+queryString.stringify({
				...queryString.parse(history.location.search), 
				level
		}))
	}

	return (
		<React.Fragment>
			{			
				parseInt(localStorage.getItem("construction_phase_level")) === 2 &&	
				<Filters>
					<Header>نمایش بر اساس</Header>	
					<Row>
						<RadioButton label="سطح یک" select={!params.level || parseInt(params.level) === 1} onSelect={() => changeLevel(1)} />
					</Row>
					<Row>
						<RadioButton label="سطح دو" select={parseInt(params.level) === 2} onSelect={() => changeLevel(2)} />
					</Row>
				</Filters>
			}
		</React.Fragment>
	);
}